import React, { useState } from 'react';

function Radio(props) {
    const radioItems = [
        {
            id: "radiator",
            title: props.DataModel.lang.water_radiators
        },
        {
            id: "underflor_heating",
            title: props.DataModel.lang.underfloor_heating
        }
    ];

    const [selectedItem, setSelectedItem] = useState(radioItems[0]);

    return (
        <div className='radio-wrapper'>
            <div className='radio-items'>
                {radioItems.map( (radioItem) => {
                    return (
                        <div className={`radio-item ${selectedItem.id === radioItem.id && "radio-item-selected"}`} key={radioItem.id} onClick={() => {
                            props.radioSetHeatDistribution(radioItem.id)
                            props.radioHideSavings()
                            setSelectedItem(radioItem)
                        }}>
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="9.5" cy="9.5" r="9.25" fill="white" stroke="black" strokeWidth="0.5"/>
                                {selectedItem.id === radioItem.id && <circle cx="9.5" cy="9.5" r="5.5" fill="#246AA2"/>}
                            </svg>

                            {radioItem.title}
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default Radio;